export default function WorkETFDetails() {
  return (
    <section className="py-10 sm:py-16">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">

        {/* Two column text section */}
        <div className="flex flex-col sm:flex-row gap-8 sm:gap-0 mb-6">

          {/* Left: description */}
          <div
            className="flex-1 flex flex-col gap-6 text-gray-700 text-sm leading-relaxed text-justify pt-6 pr-0 sm:pr-16 sm:ml-60"
            style={{ textAlignLast: "left" }}
          >
            <p>
              Hook is a new app that makes music discovery easier and
              faster. It's a social music platform that makes it fun and easy to
              adjust, personalize and broadcast your favorite music moments.
            </p>
            <p>
              Guys came to us with a request to do something special, fresh,
              minimalistic, youthful, and bright. Based on their request, it is
              supposed to look like the aesthetic of works designed by
              Pharrell Williams, and Tyler the Creator, — light, pastel, and
              even pink, cute barring in mind a mood in the spirit of the
              track "Happy" by Pharrell Williams. We did it!
            </p>
          </div>

          {/* Right: what we did */}
          <div className="sm:w-56 flex-shrink-0 pt-6 sm:pl-16 sm:mr-60">
            <h3 className="font-bold text-black text-xl mb-4">What we did</h3>
            <ul className="flex flex-col gap-2 text-black text-xl font-bold">
              {[
                "Event Branding",
                "Motion",
                "Visual Design",
                "E. Branding",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="text-black">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
}